// src/js/static-pages.js
import { initializeThemeToggle } from "./core/theme-toggle.js";
import { initializeAuth } from "./core/auth.js";
import { initializeStripeUI } from "./core/stripe.js";
import { registerServiceWorker } from "./core/serviceWorker.js";

export function initializeStaticPage() {
  // Initialize only what's needed for header
  initializeThemeToggle();
  initializeAuth();
  initializeStripeUI();
  registerServiceWorker();
}
